import React from "react";
import { useSelector } from "react-redux";
import Avatar from "../../../../shared/components/ui/avatar/Avatar";
import ButtonPopup from "../../../../shared/components/ui/buttonPopup/ButtonPopup";
import HoldersPopup from "./holdersPopup/HoldersPopup";
import { getInitials } from "../../../../shared/utils/utils";
import classes from "./PermissionHoldersStrip.module.css";

const MAX_VISIBLE = 5;

const PermissionHoldersStrip = ({ roleHolders = [] }) => {
    const { texts } = useSelector((state) => state.translate);
    const avatarColors = useSelector((state) => state.uiData.general?.avatarColors);

    const hasOverflow = roleHolders.length > MAX_VISIBLE;
    const visibleAvatars = hasOverflow ? roleHolders.slice(0, MAX_VISIBLE) : roleHolders;
    const overflowCount = roleHolders.length - MAX_VISIBLE;

    return (
        <div className={classes.Strip}>
            <span className={classes.Label}>{texts.managedBy}</span>
            <span className={classes.SubLabel}>{texts.managedByRoles}</span>
            <div className={classes.AvatarStack}>
                {visibleAvatars.map((holder, index) => (
                    <Avatar
                        key={holder.id}
                        color={avatarColors?.[index % avatarColors?.length]}
                        initials={getInitials(holder.firstName, holder.lastName)}
                        title={`${holder.firstName} ${holder.lastName}`}
                        size={28}
                        className={classes.StackAvatar}
                    />
                ))}

                {hasOverflow && (
                    <ButtonPopup
                        button={
                            <Avatar
                                isOverflow
                                overflowCount={overflowCount}
                                size={28}
                                className={classes.StackAvatar}
                            />
                        }
                    >
                        <HoldersPopup holders={roleHolders} />
                    </ButtonPopup>
                )}
            </div>
        </div>
    );
};

export default PermissionHoldersStrip;
